import { useNavigate, useLocation } from 'react-router-dom';

export const useNavigateWithPrevPageState = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithPrevPageState = (route: string) => {
    return navigate(route, {
      state: { prevPage: location.pathname + location.search },
    });
  };

  return navigateWithPrevPageState;
};
